// extracted by mini-css-extract-plugin
export default {"suggestionListItem":"AddressSearchInput_suggestionListItem__u+Cup"};